// src/styles/fontStyles.js
const fontStyles = `
  @font-face {
    font-family: 'Helvetica';
    src: url('../public/assets/fonts/Helvetica-Bold-Font.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }
`;

export default fontStyles;